<template>
  <v-btn
    color="default"
    @click="handleClick"
  >
    {{ $t('common.SAVE') }}
  </v-btn>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit("click")
    },
  },
}
</script>
